import './aprilstable/style';
import FormStructure from './aprilstable/form_structure';

export default FormStructure;